exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2L8pMi2-SDcYA-yY8nT9qm{display:inline-block;width:6px;height:15px;vertical-align:middle}html[dir=ltr] ._2L8pMi2-SDcYA-yY8nT9qm,html[dir=rtl] ._2L8pMi2-SDcYA-yY8nT9qm{margin-left:10px;margin-right:10px}", ""]);
// Exports
exports.locals = {
	"showAsItem": "_2L8pMi2-SDcYA-yY8nT9qm"
};